<ng-container *transloco="let t" class="container">
  <app-admin-modal-layout
          [title]="title ?? ''"
          [cancelLabel]="dismissButtonTitle ?? t('app.common.cancel')"
          (onClose)="onDismissClick()"
          [showSave]="false"
  >

    <table class="w-100">
      <thead class="admin-modal-table-underline">
      <tr>
        <th class="py-6">{{ t('organiser.event.details.control.point.name') }}</th>
        <th class="py-6 point-type-width">{{ t('organiser.event.details.control.point.type') }}</th>
        <th class="py-6 text-center">Copy</th>
        <th class="py-6 text-center delete-width">Delete</th>
      </tr>
      </thead>
      <tbody>
      @for (waypoint of listOfWaypoints; track waypoint.id; ) {
      <tr class="admin-modal-table-underline">
        <td class="center-align">
          <app-language-output [hrLabel]="waypoint.pointNameHr" [enLabel]="waypoint.pointNameEn"
                               [itLabel]="waypoint.pointNameIt" [siLabel]="waypoint.pointNameSlo" [srLabel]="waypoint.pointNameSr" [bsLabel]="waypoint.pointNameBs"
                               [defaultLanguage]="raceWaypointsComponent!.event!.defaultLanguage"
                               [languages]="raceWaypointsComponent!.languages"/>
        </td>
        <td class="py-6">
          <div class="status-badge mb-4px  text-center"
               [ngClass]="{'blue': waypoint.waypointTypeId === WaypointType.START_WAYPOINT , 'accepted':
      waypoint.waypointTypeId === WaypointType.CONTROL_WAYPOINT, 'denied': waypoint.waypointTypeId === WaypointType.FINISH_WAYPOINT ,
      'on-hold': waypoint.waypointTypeId === WaypointType.OTHER_WAYPOINT}">
                              <span class="fw-bold">
      {{
      t("organiser.event.details.control.point.waypointType."
        + waypoint.waypointTypeId) | uppercase
      }}
      </span>
    </div>
    </td>
      <td class="py-6 text-center cursor-pointer">
      <i class="fa-regular fa-copy" (click)="onCopyWaypoint(waypoint)" ngbTooltip="{{ t('organiser.event.details.control.point.copy') }}"
                   placement="left"></i>
              </td>
              <td class="py-6 text-center cursor-pointer">
                <i class="fas fa-trash-alt color-primary" (click)="onDeleteWaypoint(waypoint)"></i>
              </td>
            </tr>
      }
      </tbody>
    </table>
  </app-admin-modal-layout>
</ng-container>
